import { render } from "./PaymentSteps.vue?vue&type=template&id=d3c39ea0&scoped=true"
const script = {}

import "./PaymentSteps.vue?vue&type=style&index=0&id=d3c39ea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c39ea0"]])

export default __exports__